import React from 'react';
import {searchkit} from './webshop';

const HitStats = (props) => {
  const {bemBlocks, hitsCount} = props

  const query = searchkit.query
  const pageFrom = query.getFrom() || 1;
  const pageSize = query.getSize() || 0;

  return (
    <div className={bemBlocks.container()} data-qa="hits-stats">
      <div className={bemBlocks.container("info")} data-qa="info">
        <b>{pageFrom}-{pageFrom + pageSize}</b> van <b>{hitsCount}</b>
      </div>
    </div>
  )
}

export default HitStats;



// WEBPACK FOOTER //
// ./src/HitsStats.js